"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _fastdom = _interopRequireDefault(require("fastdom"));

var _Aria2 = _interopRequireDefault(require("./Aria"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Manage tablist elements
 *
 * @param {Object} config - Config options for AriaTablist
 * @param {HTMLElement} config.tablist - The tab elements' parent element
 * @param {NodeList} config.panels - A list of panel elements; each panel should have a corresponding tab element in config.tabs
 *
 * E.g.:
 * const tablist = new AriaTablist({
 *   tablist: tabsWrapper,
 *   panels: panelElements,
 * });
 */
var AriaTablist = /*#__PURE__*/function (_Aria) {
  (0, _inherits2.default)(AriaTablist, _Aria);

  var _super = _createSuper(AriaTablist);

  function AriaTablist(config) {
    var _this;

    (0, _classCallCheck2.default)(this, AriaTablist);
    _this = _super.call(this);
    _this.tablist = config.tablist;
    _this.panels = config.panels;
    _this.index = 0;
    _this.key = {
      arrows: /37|39|40/,
      // left, right, or down
      arrLeftRight: /37|39/,
      arrLeft: 37,
      arrRight: 39,
      arrDown: 40
    };
    _this.tablistChildren = Array.prototype.slice.call(_this.tablist.children);
    _this.panels = Array.prototype.slice.call(_this.panels); // Required markup is `<li><a href=""></a></li>`

    _this.tabs = _this.tablistChildren.filter(function (child) {
      return null !== child.querySelector('a[href]');
    }).map(function (child) {
      return child.querySelector('a[href]');
    }); // Bail if there's a mismatch in tabs and panels

    if (_this.tabs.length !== _this.panels.length) {
      // eslint-disable-next-line max-len
      console.error('AriaTablist requires an equal number of tabs and tabpanels');
      return (0, _possibleConstructorReturn2.default)(_this);
    } // Bind class methods


    _this.shiftTabKeyDown = _this.shiftTabKeyDown.bind((0, _assertThisInitialized2.default)(_this));
    _this.keyDownHandler = _this.keyDownHandler.bind((0, _assertThisInitialized2.default)(_this));
    _this.arrowKeyDown = _this.arrowKeyDown.bind((0, _assertThisInitialized2.default)(_this));
    _this.tabKeyDown = _this.tabKeyDown.bind((0, _assertThisInitialized2.default)(_this));
    _this.ariaSwitchTab = _this.ariaSwitchTab.bind((0, _assertThisInitialized2.default)(_this));
    _this._updateTabs = _this._updateTabs.bind((0, _assertThisInitialized2.default)(_this));
    _this.updateTabs = _this.updateTabs.bind((0, _assertThisInitialized2.default)(_this));
    _this.destroy = _this.destroy.bind((0, _assertThisInitialized2.default)(_this));

    _Aria2.default.eventPolyfill();

    _this.init();

    return _this;
  }
  /**
   * Add necessary attributes and event listeners; collect interactive elements.
   */


  (0, _createClass2.default)(AriaTablist, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      this.tablist.setAttribute('role', 'tablist'); // role=tab, aria-selected

      this.tabs.forEach(function (tab, index) {
        if ('LI' === tab.parentElement.nodeName) {
          tab.parentElement.setAttribute('role', 'presentation');
        }

        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-selected', "".concat(_this2.index === index));

        if (_this2.index === index) {
          tab.setAttribute('tabindex', '0');
        } else {
          tab.setAttribute('tabindex', '-1');
        }

        tab.addEventListener('click', _this2.ariaSwitchTab);
        tab.addEventListener('keydown', _this2.keyDownHandler);
      }); // role=tabpanel, aria-labelledby, aria-hidden

      this.panels.forEach(function (panel, index) {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-hidden', "".concat(_this2.index !== index));
      });
      this.targetElement = this.panels[this.index];
      this.collectInteractiveChildren();
      this.panels[this.index].addEventListener('keydown', this.shiftTabKeyDown);

      _Aria2.default.dispatchAriaEvent('tablistinit', {
        activePanel: this.panels[this.index]
      }, this.tablist);
    }
    /**
     * TAB from the active panel's first focusable element back to the active tab.
     *
     * @param {Object} event The event object.
     */

  }, {
    key: "shiftTabKeyDown",
    value: function shiftTabKeyDown(event) {
      if (event.keyCode === this.tabKey && event.shiftKey) {
        var focusIndex = this.interactiveChildElements.indexOf(document.activeElement);

        if (0 === focusIndex) {
          var currentPanel = this.panels.filter(function (panel) {
            return 'false' === panel.getAttribute('aria-hidden');
          });
          var panelIndex = this.panels.indexOf(currentPanel[0]);
          event.preventDefault();
          this.tabs[panelIndex].focus();
        }
      }
    }
    /**
     * Handle tablist key presses.
     *
     * @param {Object} event The event object.
     */

  }, {
    key: "keyDownHandler",
    value: function keyDownHandler(event) {
      if (event.keyCode === this.tabKey && !event.shiftKey) {
        this.tabKeyDown(event);
      } else if (this.key.arrows.test(event.keyCode)) {
        this.arrowKeyDown(event);
      }
    }
    /**
     * Move focus from active tab to active panel's first child.
     *
     * @param {Object} event The event object.
     */

  }, {
    key: "tabKeyDown",
    value: function tabKeyDown(event) {
      if (this.interactiveChildElements.length) {
        event.preventDefault();
        this.interactiveChildElements[0].focus();
      }
    }
    /**
     * Navigate through tablist with arrow keys.
     *
     * @param {Object} event The event object.
     */

  }, {
    key: "arrowKeyDown",
    value: function arrowKeyDown(event) {
      var newIndex = null;
      var deactivate = {};
      var activate = {};
      var currentIndex = this.tabs.indexOf(event.currentTarget);
      deactivate.tab = this.tabs[currentIndex];
      deactivate.panel = this.panels[currentIndex];
      this.panels.forEach(function (panel) {
        panel.removeAttribute('tabindex');
      });

      if (this.key.arrLeftRight.test(event.keyCode)) {
        switch (event.keyCode) {
          case this.key.arrLeft:
            newIndex = currentIndex - 1;
            break;

          case this.key.arrRight:
            newIndex = currentIndex + 1;
            break;

          default:
            newIndex = null;
        }

        if (undefined !== this.tabs[newIndex]) {
          event.preventDefault();
          activate.index = newIndex;
          activate.tab = this.tabs[newIndex];
          activate.panel = this.panels[newIndex];
          this.updateTabs(deactivate, activate);
          activate.tab.focus();
        }
      } else if (event.keyCode === this.key.arrDown) {
        event.preventDefault();
        this.panels[currentIndex].setAttribute('tabindex', '-1');
        this.panels[currentIndex].focus();
      }
    }
    /**
     * Externally-exposed tab updater method
     */

  }, {
    key: "updateTabs",
    value: function updateTabs(deactivate, activate) {
      var _this3 = this;

      _fastdom.default.mutate(function () {
        _this3._updateTabs(deactivate, activate);
      });
    }
    /**
     * Toggle active panel based on active tab.
     *
     * @param {Object} deactivate
     * @param {HTMLElement} deactivate.tab The tab item to deactivate.
     * @param {HTMLElement} deactivate.panel The panel to deactivate.
     * @param {Object} activate
     * @param {HTMLElement} activate.tab The tab item to activate.
     * @param {HTMLElement} activate.panel The panel to activate.
     * @private
     */

  }, {
    key: "_updateTabs",
    value: function _updateTabs(deactivate, activate) {
      var selected = 'false';
      var hidden = 'true';

      if (null !== deactivate.tab || null !== activate.tab || null !== deactivate.panel || null !== activate.panel) {
        // Update current tab
        deactivate.tab.setAttribute('tabindex', '-1');
        deactivate.tab.setAttribute('aria-selected', selected);
        deactivate.panel.setAttribute('aria-hidden', hidden);
        this.targetElement = deactivate.panel;
        this.collectInteractiveChildren();
        Array.prototype.forEach.call(this.interactiveChildElements, function (focusElement) {
          focusElement.setAttribute('tabindex', '-1');
        });
        deactivate.panel.removeEventListener('keydown', this.shiftTabKeyDown); // Update new active tab

        var _ref = [hidden, selected];
        selected = _ref[0];
        hidden = _ref[1];
        activate.tab.setAttribute('tabindex', '0');
        activate.tab.setAttribute('aria-selected', selected);
        activate.panel.setAttribute('aria-hidden', hidden);
        this.targetElement = activate.panel;
        this.collectInteractiveChildren();
        Array.prototype.forEach.call(this.interactiveChildElements, function (element) {
          if ('-1' === element.getAttribute('tabindex')) {
            element.removeAttribute('tabindex');
          }
        });
        this.index = activate.index;
        activate.panel.addEventListener('keydown', this.shiftTabKeyDown);

        _Aria2.default.dispatchAriaEvent('tablistchange', {
          activePanel: this.panels[this.index]
        }, this.tablist);
      }
    }
    /**
     * Collect tab and panel info then toggle tabs/panels.
     *
     * @param {Object} event The event object.
     */

  }, {
    key: "ariaSwitchTab",
    value: function ariaSwitchTab(event) {
      var deactivate = {};
      var activate = {};
      event.preventDefault();

      if ('true' !== event.target.getAttribute('aria-selected')) {
        deactivate.tab = this.tablist.querySelector('[aria-selected="true"]');
        var currentTablistIndex = this.tabs.indexOf(deactivate.tab);
        deactivate.panel = this.panels[currentTablistIndex];
        activate.index = this.tabs.indexOf(event.target);
        activate.tab = this.tabs[activate.index];
        activate.panel = this.panels[activate.index];
        this.updateTabs(deactivate, activate);
      }
    }
    /**
     * Destroy the tablist, removing ARIA attributes and event listeners
     */

  }, {
    key: "destroy",
    value: function destroy() {
      var _this4 = this;

      this.tablist.removeAttribute('role');
      this.tabs.forEach(function (tab, index) {
        tab.removeAttribute('role');
        tab.removeAttribute('aria-selected');

        if (_this4.index !== index) {
          tab.removeAttribute('tabindex');
        }

        tab.removeEventListener('click', _this4.ariaSwitchTab);
        tab.removeEventListener('keydown', _this4.keyDownHandler);
      });
      this.panels.forEach(function (panel) {
        panel.removeAttribute('role');
        panel.removeAttribute('aria-hidden');
      });
      this.targetElement = this.panels[this.index];
      this.collectInteractiveChildren();
      this.panels[this.index].removeEventListener('keydown', this.shiftTabKeyDown);

      _Aria2.default.dispatchAriaEvent('tablistdestroy', {
        activePanel: null
      }, this.tablist);
    }
  }]);
  return AriaTablist;
}(_Aria2.default);

exports.default = AriaTablist;